// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__h8wJe","upload":"Small_upload__2m_Gl","imageWrap":"Small_imageWrap__3xFwZ","removeBtn":"Small_removeBtn__3v_gG"};